import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function Layout({ children }: { children: React.ReactNode }) {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const isAdmin = user?.role === 'admin';
  const canManageGear = user?.role === 'admin' || user?.role === 'quartermaster';

  const roleBadge = isAdmin ? 'Admin' : user?.role === 'quartermaster' ? 'Quartermaster' : null;

  const isStandardUser = user?.role === 'user';

  const navItems = [
    ...(canManageGear ? [{ path: '/', label: 'Dashboard', icon: 'grid' }] : []),
    { path: '/inventory', label: 'Inventory', icon: 'list' },
    { path: '/retired', label: 'Retired', icon: 'archive' },
    ...(isAdmin ? [{ path: '/users', label: 'Users', icon: 'users' }] : []),
    ...(canManageGear ? [{ path: '/department', label: 'Dept Config', icon: 'settings' }] : []),
    ...(canManageGear ? [{ path: '/import', label: 'Import', icon: 'upload' }] : []),
    ...(canManageGear ? [{ path: '/inspections', label: 'Inspections', icon: 'check' }] : []),
    { path: '/activity', label: 'Activity', icon: 'clock' },
    { path: '/account', label: 'My Account', icon: 'user' },
  ];

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f3f4f6' }}>
      {/* Top nav bar */}
      <header style={{
        background: '#b91c1c', color: 'white', padding: '0 16px',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        height: 56, position: 'sticky', top: 0, zIndex: 100,
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <button onClick={() => setMenuOpen(!menuOpen)}
            style={{ background: 'none', border: 'none', color: 'white', fontSize: 24, cursor: 'pointer', display: 'none', padding: 4 }}
            className="mobile-menu-btn">
            ☰
          </button>
          <Link to={isStandardUser ? '/inventory' : '/'} style={{ color: 'white', textDecoration: 'none', fontWeight: 700, fontSize: 18 }}>
            PPE Tracker
          </Link>
        </div>

        {/* Desktop nav */}
        <nav className="desktop-nav" style={{ display: 'flex', gap: 4 }}>
          {navItems.map(item => (
            <Link key={item.path} to={item.path}
              style={{
                color: 'white', textDecoration: 'none', padding: '8px 12px',
                borderRadius: 6, fontSize: 14, fontWeight: 500,
                background: location.pathname === item.path ? 'rgba(255,255,255,0.2)' : 'transparent',
              }}>
              {item.label}
            </Link>
          ))}
        </nav>

        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <Link to="/account" style={{ color: 'white', textDecoration: 'none', fontSize: 13, opacity: 0.9 }}>
            {user?.first_name} {user?.last_name}
            {roleBadge && <span style={{ marginLeft: 4, fontSize: 11, background: 'rgba(255,255,255,0.2)', padding: '2px 6px', borderRadius: 4 }}>{roleBadge}</span>}
          </Link>
          <button onClick={handleLogout}
            style={{ background: 'rgba(255,255,255,0.15)', border: 'none', color: 'white', padding: '6px 12px', borderRadius: 6, cursor: 'pointer', fontSize: 13 }}>
            Logout
          </button>
        </div>
      </header>

      {/* Mobile nav overlay */}
      {menuOpen && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 99, background: 'rgba(0,0,0,0.4)' }}
          onClick={() => setMenuOpen(false)}>
          <nav style={{ background: 'white', width: 260, height: '100%', padding: '72px 8px 16px', boxShadow: '2px 0 8px rgba(0,0,0,0.1)' }}
            onClick={e => e.stopPropagation()}>
            {navItems.map(item => (
              <Link key={item.path} to={item.path}
                onClick={() => setMenuOpen(false)}
                style={{
                  display: 'block', textDecoration: 'none', padding: '12px 16px',
                  borderRadius: 8, fontWeight: 500,
                  background: location.pathname === item.path ? '#fef2f2' : 'transparent',
                  color: location.pathname === item.path ? '#b91c1c' : '#333',
                }}>
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
      )}

      {/* Main content */}
      <main style={{ maxWidth: 1200, margin: '0 auto', padding: 16 }}>
        {children}
      </main>

      <style>{`
        @media (max-width: 768px) {
          .desktop-nav { display: none !important; }
          .mobile-menu-btn { display: block !important; }
        }
      `}</style>
    </div>
  );
}
